
import axios from "axios";

// let url = window.location.href.includes('prod') ? 'https://shipmentmanagement-prod.azurewebsites.net/api/' :  'https://shipmentmanagement.azurewebsites.net/api/'
let url = window.location.href.includes('prod') ? 'https://shipmentmanagement-prod-cc-ftd2bwa7b3guf6br.canadacentral-01.azurewebsites.net/api/' : 'https://shipmentmanagement-dev-cudfhcgkase9dga5.southcentralus-01.azurewebsites.net/api/'

export const client = axios.create({
  baseURL: url
});

let s3sUrl = window.location.href.includes('prod') ? "https://shipment-management-backend-prod.braveisland-6187ac05.westus2.azurecontainerapps.io/api/v1/" : "https://shipment-management-backend.redisland-6862ce7c.westus2.azurecontainerapps.io/api/v1/"

export const s3sClient = axios.create({
  baseURL: s3sUrl
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }
);

s3sClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response && error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }

);


